import React from 'react';
import { Outlet } from 'react-router-dom';
import { IconsProvider } from '@ab-inbev-maz/compass';
import Header from './Header';
import ModalContainer from './ModalContainer';
import { useSession } from '../features/sso-auth/hooks/useSession';

// Same as RootLayout but without the Sidebar, for full-screen views (e.g. canvas editor).
const HeaderOnlyLayout: React.FC = () => {
  useSession();

  return (
    <IconsProvider>
      <div className="flex flex-col h-screen bg-white">
        <Header />
        <main className="flex-1 overflow-hidden relative">
          <ModalContainer />
          <Outlet />
        </main>
      </div>
    </IconsProvider>
  );
};

export default HeaderOnlyLayout;
